import React, {useMemo, useState} from 'react'
import {Alert, Button, Form, ListGroup, Modal} from 'react-bootstrap';
import partnerService from '../../api/partner.api';
import { IUserList } from '../../types/user/IUserList';
import {UseMutationOptions} from "@tanstack/react-query";
import {toast} from "react-toastify";
type AssignEmployeeVariables = {
    companyId: number;
    userId: number;
    vacancyCompanyId: number
};

type AssignEmployeeMutation = (
  variables: AssignEmployeeVariables,
  options?: UseMutationOptions<string, Error, AssignEmployeeVariables>
) => void;

type Props = {
    id: number
    update: () => void
    handleAssign?: AssignEmployeeMutation
    vacancyCompanyId?: number
}

const SignEmployee = (props: Props) => {

    const [show, setShow] = useState(false);

    const [result, setResult] = useState<IUserList[]>([])

    const [userId, setUserId] = useState<number | null>(null)

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    }

    const [error, setError] = useState<string>('')

    const [searchQuery, setSearchQuery] = useState('')

    const handleSearch = (value: string) => {
        setSearchQuery(value)
        if (value.length > 2) {
            partnerService.findUser(value).then((response) => {
                setResult(response.data)
            }).catch((error) => {
                console.log(error)
            })
        } else {
            setResult([])
        }

    }

    const assignEmployee = (userId: number, vacancyCompanyId: number) => {
        props.handleAssign && props.handleAssign(
          { companyId: props.id, userId: userId, vacancyCompanyId:  vacancyCompanyId},
          {
              onSuccess: () => {
                  toast.success("Сотрудник успешно назначен!");
                  setSearchQuery('');
                  setResult([]);
                  props.update();
                  handleClose();
              },
              onError: (error) => {
                  toast.error("Ошибка при назначении сотрудника: " + (error?.message || "Неизвестная ошибка"));
              },

          }
        );
    };
    const selectedUser: IUserList | null = useMemo(() => {
        return result.find((user) => user.id === userId) || null;
    }, [result, userId]);

    return <>
        <Button variant="primary" onClick={handleShow}>Добавить сотрудника</Button>

        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>Добавление сотрудника</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Поиск по почте, имени или фамилии</Form.Label>
                        <Form.Control type="text" value={searchQuery} onChange={(e) => handleSearch(e.target.value)} />
                    </Form.Group>
                    <ListGroup className="my-3">
                        {result.length > 0 &&
                          result.map((item) => (
                            <ListGroup.Item key={item.id}>
                                <Form.Check
                                  type="radio"
                                  label={`${item.firstName} ${item.secondName} (${item.email})`}
                                  onChange={() => setUserId(item.id)}
                                  checked={userId === item.id}
                                  id={`user-radio-${item.id}`}
                                  name="user-selection" // Группируем радиокнопки
                                />
                            </ListGroup.Item>
                          ))}
                    </ListGroup>

                    {
                        error !== '' && <Form.Text className="text-danger">{error}</Form.Text>
                    }

                    {
                        userId && (
                          <div>
                              {(selectedUser?.vacancyCompany?.name || selectedUser?.company?.name) && (
                                <Alert variant="warning">
                                    <strong>Внимание!</strong>{' '}
                                    {selectedUser?.vacancyCompany?.name
                                      ? `Этот кандидат сотрудник заказчика: `
                                      : `Этот кандидат сотрудник партнера: `}
                                    <div className="fw-bold">
                                      {selectedUser?.vacancyCompany?.name || selectedUser?.company?.name}
                                    </div>
                                </Alert>
                              )}

                              <Button onClick={async () => {
                                  setError('')
                                  if (props.handleAssign && props.vacancyCompanyId) {
                                      await assignEmployee( userId, props.vacancyCompanyId)
                                      return
                                  }
                                  partnerService.assignEmployee(props.id, userId).then((response) => {
                                      setSearchQuery('')
                                      setResult([])
                                      props.update()
                                      handleClose()
                                  }).catch((error) => {
                                      console.log(error)
                                      setError('Кол-во сотрудников заполнено. Увеличьте лимит пользователей.')
                                  })
                              }}>Добавить</Button>
                          </div>
                      )
                    }

                </Form>
            </Modal.Body>
        </Modal>
    </>
}

export default SignEmployee